const AUTH_KEY = "auth_token";
const SHOPPING_CART = "shopping_cart";
const COMPARE = "compare";
const totalPriceWithDiscount = "totalPriceWithDiscount";
const totalPriceWithoutDiscount = "totalPriceWithoutDiscount";
const totalSelecteItems = "totalSelecteItems";

class UserStorage {
  logout() {
    return localStorage.removeItem(AUTH_KEY);
  }

  setUser(token: string) {
    localStorage.setItem(AUTH_KEY, token);
  }

  getUser() {
    const token = localStorage.getItem(AUTH_KEY);
    return token;
  }

  getStoredForCompare() {
    var resultAsString = localStorage.getItem(COMPARE);
    var storedItems = resultAsString ? JSON.parse(resultAsString) : [];
    return storedItems;
  }

  addItemForCompare(item: any) {
    var storedItems = this.getStoredForCompare();
    storedItems.push(item);
    localStorage.setItem(COMPARE, JSON.stringify(storedItems));
  }

  removeItemForCompare(id: any) {
    var storedItems = this.getStoredForCompare();
    const idToRemove = storedItems.map((i: any) => i._id).indexOf(id);

    if (idToRemove !== -1) {
      storedItems.splice(idToRemove, 1);
      localStorage.setItem(COMPARE, JSON.stringify(storedItems));
    }
  }

  getStoredInCart() {
    var resultAsString = localStorage.getItem(SHOPPING_CART);
    var storedItems = resultAsString ? JSON.parse(resultAsString) : [];
    return storedItems;
  }

  updateCartItems(items: any) {
    // var storedItems = this.getStoredInCart();
    // storedItems.push(item);
    localStorage.setItem(SHOPPING_CART, JSON.stringify(items));
  }

  removeItemFromCart(id: any) {
    var storedItems = this.getStoredInCart();
    const idToRemove = storedItems.map((i: any) => i._id).indexOf(id);

    if (idToRemove !== -1) {
      storedItems.splice(idToRemove, 1);
      localStorage.setItem(SHOPPING_CART, JSON.stringify(storedItems));
    }
  }

  resetCart() {
    localStorage.removeItem(SHOPPING_CART);
    localStorage.removeItem(totalPriceWithDiscount);
    localStorage.removeItem(totalPriceWithoutDiscount);
    localStorage.removeItem(totalSelecteItems);
  }

  updateTotalPriceWithDiscount(number: number) {
    localStorage.setItem(totalPriceWithDiscount, number.toString());
  }

  updateTotalPriceWithoutDiscount(number: number) {
    localStorage.setItem(totalPriceWithoutDiscount, number.toString());
  }
  updateTotalSelectedItems(number: number) {
    localStorage.setItem(totalSelecteItems, number.toString());
  }

  selectTotalPriceWithDiscount() {
    const price = localStorage.getItem(totalPriceWithDiscount);
    return price ?? 0;
  }
  selectTotalPriceWithoutDiscount() {
    const price = localStorage.getItem(totalPriceWithoutDiscount);
    return price ?? 0;
  }
  selectTotalSelectedItems() {
    const itemsCount = localStorage.getItem(totalSelecteItems);
    return itemsCount ?? 0;
  }
}
const userStorage = new UserStorage();

export default userStorage;
